var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "feature-plan-wrapper", on: { click: _vm.showPlans } },
    [
      _c(
        "div",
        { staticClass: "feature-plan-wrapper-head" },
        [
          _c("WebhookIntegration"),
          _vm._v("\n        " + _vm._s(_vm.plan.altTitle) + "\n    "),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "feature-plan-wrapper-footer" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.isSelected
                ? _vm.$t("billing.packageManagement")
                : _vm.$t("billing.buyNow")
            ) +
            "\n    "
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }